import * as React from "react";

const SortArrow: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 320 320" fill="currentColor" style={{"enableBackground":"new 0 0 320 320"} as any} xmlSpace="preserve">
<path d="M26.9,66.6h266.2c23.9,0,35.9,29,19,45.9L179,245.5c-10.5,10.5-27.5,10.5-37.9,0L8,112.4C-9,95.5,2.9,66.6,26.9,66.6z"/>
</svg>;
};

export default React.memo(SortArrow);
